import { useEffect, useRef } from "react";
import debounce from "debounce";

const useDebouncedSearch = ({ delay = 500, onSearch, onReset }) => {
  const onSearchRef = useRef(onSearch);
  const onResetRef = useRef(onReset);

  useEffect(() => {
    onSearchRef.current = onSearch;
    onResetRef.current = onReset;
  }, [onSearch, onReset]);

  const debouncedSearch = useRef(
    debounce((value) => {
      if (!value.trim()) {
        onResetRef.current?.();
      } else {
        onSearchRef.current?.(value.trim());
      }
    }, delay)
  ).current;

  const handleChange = (value) => {
    debouncedSearch(value);
  };

  return handleChange;
};

export default useDebouncedSearch;
